var normalizeStoreName = function normalizeStoreName() {
  var storeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'magazine';
  return (storeName == null ? void 0 : storeName.startsWith(prefix)) ? storeName : "".concat(prefix).concat(storeName);
};
export default normalizeStoreName;